import React from "react";
import moment from "moment";

function ConsentPrint({ object }) {
  const completeAddress =
    object?.present_houseNumber +
    ", " +
    object?.present_street +
    ", " +
    object?.present_subdivision +
    ", " +
    object?.present_barangay +
    ", " +
    object?.present_city +
    ", " +
    object?.present_province +
    ", " +
    object?.present_zipCode;

  const names = [
    {
      field: "Last Name",
      value: object?.lastName,
    },
    {
      field: "First Name",
      value: object?.firstName,
    },
    {
      field: "Middle Name",
      value: object?.middleName,
    },
  ];
  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      timeZone: "Asia/Manila",
    });
  };
  const datas = [
    {
      field: "CLIENT ASSIGNED",
      value: object?.deployedAt,
    },
    {
      field: "DATE HIRED",
      value: formatDate(object?.hireDate),
    },
    {
      field: "DATE START",
      value: formatDate(object?.startDate),
    },
  ];

  const values = [
    object?.lastName,
    "",
    object?.positionApplied,
    object?.birthDate,
    completeAddress,
  ];

  const reminder = (
    <div style={{ display: `flex`, flexDirection: `column` }}>
      <b style={{ fontSize: `0.7rem` }}>NOTE: PLEASE READ!</b>
      <b style={{ color: `red`, alignSelf: `center`, fontSize: `0.7rem` }}>
        SCHEDULE OF SIGNING:
      </b>
      <b style={{ textAlign: `center`, fontSize: `0.7rem` }}>
        MONDAY-WEDNESDAY-FRIDAY
      </b>
      <b style={{ textAlign: `center`, fontSize: `0.7rem` }}>*9AM *1PM *9AM</b>
      <b style={{ textAlign: `center`, fontSize: `0.7rem` }}>
        LATE COMERS WILL NOT BE ENTERTAINED!!!
      </b>
    </div>
  );

  const singlePageStyles = `
      @media print {
        .single-page-container {
          height: 100vh !important;
          max-height: 100vh !important;
          page-break-after: avoid !important;
          page-break-inside: avoid !important;
          overflow: hidden !important;
          transform-origin: top left !important;
        }
        @page {
          size: A4 !important;
          margin: 0.5in !important;
        }
        body {
          margin: 0 !important;
          padding: 0 !important;
        }
      }
      .single-page-container {
        height: 100vh;
        max-height: 100vh;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        transform-origin: top left;
        box-sizing: border-box;
      }
      .auto-scale-content {
        flex: 1;
        display: flex;
        flex-direction: column;
        min-height: 0;
        transform-origin: top left;
        /* Base font size that will be scaled */
        font-size: 16px;
        line-height: 1.3;
        font-family: "Montserrat", sans-serif;
        width: 100%;
        padding: 0 3rem;
      }
    `;

  React.useEffect(() => {
    const styleElement = document.createElement("style");
    styleElement.textContent = singlePageStyles;
    document.head.appendChild(styleElement);

    const autoScale = () => {
      const container = document.querySelector(".single-page-container");
      const content = document.querySelector(".auto-scale-content");

      if (!container || !content) return;

      content.style.transform = "scale(1)";
      content.style.fontSize = "16px";

      const containerHeight = container.clientHeight;
      const contentHeight = content.scrollHeight;

      if (contentHeight > containerHeight) {
        const scale = containerHeight / contentHeight;

        content.style.transform = `scale(${scale})`;
        content.style.transformOrigin = "top left";

        content.style.fontSize = `${16 * scale}px`;
      }
    };

    setTimeout(autoScale, 100);

    window.addEventListener("resize", autoScale);
    window.addEventListener("beforeprint", autoScale);

    return () => {
      document.head.removeChild(styleElement);
      window.removeEventListener("resize", autoScale);
      window.removeEventListener("beforeprint", autoScale);
    };
  }, []);

  return (
    <div className="single-page-container">
      <div className="auto-scale-content">
        <div
          className="card"
          style={{
            fontFamily: `"Montserrat", sans-serif`,
            width: "100%",
            padding: `0 3rem`,
          }}
        >
          <div
            style={{
              display: `flex`,
              flexDirection: `column`,
              width: `100%`,
            }}
          >
            <div
              style={{
                display: `flex`,
                width: `100%`,
                height: `100%`,
                justifyContent: `center`,
              }}
            >
              <img style={{ width: `25%` }} src="/logo.png"></img>
            </div>
            <div
              style={{
                display: `flex`,
                justifyContent: `center`,
                marginTop: `1rem`,
              }}
            >
              <div
                style={{
                  display: `flex`,
                  flexDirection: `column`,
                }}
              >
                <p
                  style={{
                    fontWeight: `700`,
                    textAlign: `center`,
                    margin: `0`,
                  }}
                >
                  LGS Centre, 1639 Dian corner, Rockefeller St. Brgy. San
                  Isidro, Makati City
                </p>
                <p
                  style={{
                    fontWeight: `700`,
                    textAlign: `center`,
                  }}
                >
                  Tel No: (02) 8889-2680
                </p>
              </div>
            </div>
            <div
              style={{
                display: `flex`,
                justifyContent: `center`,
                marginTop: `2.5rem`,
              }}
            >
              <p
                style={{
                  fontWeight: `500`,
                }}
              >
                ENDORSEMENT FORM/INFORMATION SHEET
              </p>
            </div>
            <table style={{ width: `80%`, margin: `0 auto` }}>
              <tbody>
                <tr>
                  <td
                    style={{
                      width: `26%`,
                    }}
                  >
                    <b>NAME:</b>
                  </td>
                  <td
                    style={{
                      textAlign: `center`,
                      borderBottom: `1px solid black`,
                      width: `24%`,
                    }}
                  >
                    {object?.lastName}
                  </td>
                  <td
                    style={{
                      textAlign: `center`,
                      borderBottom: `1px solid black`,
                      width: `25%`,
                    }}
                  >
                    {object?.firstName}
                  </td>
                  <td
                    style={{
                      textAlign: `center`,
                      borderBottom: `1px solid black`,
                      width: `25%`,
                    }}
                  >
                    {object?.middleName}
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td
                    style={{
                      textAlign: `center`,
                      fontSize: `0.8rem`,
                      fontWeight: `700`,
                    }}
                  >
                    Last Name
                  </td>
                  <td
                    style={{
                      textAlign: `center`,
                      fontSize: `0.8rem`,
                      fontWeight: `700`,
                    }}
                  >
                    First Name
                  </td>
                  <td
                    style={{
                      textAlign: `center`,
                      fontSize: `0.8rem`,
                      fontWeight: `700`,
                    }}
                  >
                    Middle Name
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      fontWeight: `700`,
                    }}
                    colSpan={1}
                  >
                    EMPLOYEE NO:
                  </td>
                  <td colSpan={1}>123456789</td>
                  <td
                    style={{ border: `1px solid gray`, padding: `1rem 0.3rem` }}
                    colSpan={2}
                    rowSpan={3}
                  >
                    {reminder}
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      fontWeight: `700`,
                    }}
                  >
                    POSITION:
                  </td>
                  <td>{object?.positionApplied}</td>
                </tr>
                <tr>
                  <td
                    style={{
                      fontWeight: `700`,
                    }}
                  >
                    DATE OF BIRTH:
                  </td>
                  <td>{moment(object?.birthDate).format("MMMM D, YYYY")}</td>
                </tr>
                <tr>
                  <td
                    style={{
                      fontWeight: `700`,
                    }}
                  >
                    COMPLETE ADDRESS:
                  </td>
                  <td colSpan={3}>{completeAddress}</td>
                </tr>
                <tr>
                  <td
                    style={{
                      fontWeight: `700`,
                      padding: `0.5rem 0`,
                    }}
                  >
                    CONTACT NUMBER:
                  </td>
                  <td>{object?.present_telephone}</td>
                </tr>
                <tr>
                  <td
                    style={{
                      fontWeight: `700`,
                      padding: `0.5rem 0`,
                    }}
                  >
                    EMAIL ADDRESS:
                  </td>
                  <td colSpan={3}>{object?.email}</td>
                </tr>
                <tr>
                  <td
                    style={{
                      fontWeight: `700`,
                      padding: `0.5rem 0`,
                    }}
                  >
                    SEX/CIVIL STATUS:
                  </td>
                  <td style={{ position: `relative` }}>
                    {object?.sex}
                    <b
                      style={{
                        position: `absolute`,
                        top: `5%`,
                        left: `100%`,
                      }}
                    >
                      REMARKS:
                    </b>
                  </td>
                </tr>
                {datas.map((data) => {
                  return (
                    <tr>
                      <td
                        style={{
                          fontWeight: `700`,
                          padding: `0.5em 0`,
                        }}
                      >
                        {data?.field}:
                      </td>
                      <td>{data?.value}</td>
                    </tr>
                  );
                })}
                <tr>
                  <td colSpan={2}></td>
                  <td
                    colSpan={2}
                    style={{ fontWeight: `700`, padding: `0.7rem 0` }}
                  >
                    DATE ISSUED & EXPIRATION
                  </td>
                </tr>
                <tr>
                  <td>
                    <b>MANDATORY NUMBERS:</b>
                  </td>
                  <td>5621</td>
                  <td>
                    <b>MEDICAL EXAM:</b>
                  </td>
                  <td>{formatDate(object?.medicalValidDate) || "N/A"}</td>
                </tr>
                <tr>
                  <td>
                    <b>SSS NO:</b>
                  </td>
                  <td>{object?.sss || "N/A"}</td>
                  <td>
                    <b>NBI CLEARANCE:</b>
                  </td>
                  <td>{formatDate(object?.nbiValidDate) || "N/A"}</td>
                </tr>
                <tr>
                  <td>
                    <b>PHILHEALTH NO:</b>
                  </td>
                  <td>{object?.philHealth || "N/A"}</td>
                </tr>
                <tr>
                  <td>
                    <b>PAB-IBIG NO:</b>
                  </td>
                  <td>{object?.pagIbig || "N/A"}</td>
                  <td>
                    <b>POLICE CLEARANCE:</b>
                  </td>
                  <td>
                    {formatDate(object?.policeClearanceValidDate) || "N/A"}
                  </td>
                </tr>
                <tr>
                  <td>
                    <b>TIN NO:</b>
                  </td>
                  <td>{object?.tin || "N/A"}</td>
                </tr>
                <tr>
                  <td>
                    <b>VALIDITY OF VACCINE:</b>
                  </td>
                  <td>{formatDate(object?.vaccineValidDate) || "N/A"}</td>
                  <td>
                    <b>BARANGAY CLEARANCE:</b>
                  </td>
                  <td>
                    {formatDate(object?.barangayClearanceValidDate) || "N/A"}
                  </td>
                </tr>
                <tr>
                  <td>
                    <b>BRAND:</b>
                  </td>
                  <td>{object?.brand || "N/A"}</td>
                </tr>
                <tr>
                  <td>
                    <b>BOOSTER:</b>
                  </td>
                  <td>{object?.booster || "N/A"}</td>
                  <td>
                    <b>HEALTH PERMIT:</b>
                  </td>
                  <td>{formatDate(object?.healthPermitValidDate) || "N/A"}</td>
                </tr>
                <tr>
                  <td colSpan={2}></td>
                  <td>
                    <b>MAYOR'S PERMIT:</b>
                  </td>
                  <td>{formatDate(object?.mayorPermitValidDate) || "N/A"}</td>
                </tr>
                <tr>
                  <td>
                    <b>IN CASE OF EMERGENCY</b>
                  </td>
                  <td colSpan={3}></td>
                </tr>
                <tr>
                  <td>
                    <b>PLS.NOTIFY:</b>
                  </td>
                  <td style={{ textAlign: `center` }}>
                    <b>FULL NAME</b>
                  </td>
                  <td style={{ textAlign: `center` }}>
                    <b>ADDRESS</b>
                  </td>
                  <td style={{ textAlign: `center` }}>
                    <b>CONTACT NO.</b>
                  </td>
                </tr>
                <tr>
                  <td>
                    <b>RELATION:</b>
                  </td>
                  <td></td>
                  <td colSpan={2}></td>
                </tr>
                <tr>
                  <td colSpan={4}>
                    <p style={{ margin: `1rem 0` }}>
                      {" "}
                      I HEREBY CERTIFY THAT THE ABOVE INFORMATION PROVIDED ARE
                      CORRECT:
                    </p>
                  </td>
                </tr>
                <tr>
                  <td colSpan={2}></td>
                  <td colSpan={2} style={{ padding: `1.5rem 0` }}>
                    <b>ENDORSED BY:</b>
                  </td>
                </tr>
                <tr>
                  <td
                    colSpan={2}
                    style={{
                      padding: `2rem 2rem 0 2rem`,
                    }}
                  >
                    <hr></hr>
                  </td>
                  <td
                    colSpan={2}
                    style={{
                      padding: `2rem 2rem 0 2rem`,
                    }}
                  >
                    <hr></hr>
                  </td>
                </tr>
                <tr>
                  <td colSpan={2} style={{ textAlign: `center` }}>
                    <b>PRINTED NAME/SIGNATURE/DATE</b>
                  </td>
                  <td colSpan={2} style={{ textAlign: `center` }}>
                    <b>AREA SUPERVISOR'S NAME & SIGNATURE/DATE</b>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ConsentPrint;
